export default {
  '--date-picker-main-color': '#fff',
  '--date-picker-body-background-color': '#303030',
  '--day-picker-head-item-color': '#aaaaaa'
};